import React from "react";
import logo from "./logo.svg";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>admin page</p>
      </header>
    </div>
  );
}

export default App;
